import { OpenAcademicTranscript } from '@/components/buttons/open-academic-transcript'
import { RequestActionButton } from '@/components/buttons/request-action-button'
import { RequestData } from '@/components/cards/request-data'
import { StartReviewModal } from '@/components/dialogs/start-review-modal'
import { StartedReviewModal } from '@/components/dialogs/started-review-modal'
import { PageContent } from '@/components/layout/page-content'
import { PageHeader } from '@/components/layout/page-header'
import { PageLayout } from '@/components/layout/page-layout'
import { CoursesEquivalences } from '@/components/tables/courses-quivalences'
import { SimulatedTranscript } from '@/components/tables/simulated-transcript'
import { RequestStatus } from '@/components/titles/request-status'
import { RequestTitle } from '@/components/titles/request-title'
import { Button } from '@/components/ui/button'
import { REQUEST_STATUS } from '@/constants/request-status'
import { formatRequestProtocol } from '@/utils/format-request-protocol'
import { getRequestStatusById } from '@/utils/get-status-by-id'
import { useRequestTypeCreditTransfer } from './hooks/use-request-type-credit-transfer'
import { useRequestTypeCreditTransferForm } from './hooks/use-request-type-credit-transfer-form'

export const RequestTypeCreditTransferPage = () => {
  const {
    states: {
      requestData,
      curriculumCourses,
      isLoading,
      isPendingStartReview,
      openReviewModal,
      openSuccessModal,
      currentCurriculum
    },
    actions: {
      handleMutate,
      setOpenReviewModal,
      handleSetSuccesModal,
      navigateToMenu,
      navigateToThisReview
    }
  } = useRequestTypeCreditTransfer()

  const {
    states: { formMethods }
  } = useRequestTypeCreditTransferForm(requestData)

  const status = getRequestStatusById(requestData?.requestStatus.id)

  return (
    <>
      <PageLayout isLoading={isLoading} loadingText="Carregando Análise">
        <PageHeader title="Menu das Solicitações" breadcrumb>
          <Button
            onClick={() => setOpenReviewModal(true)}
            disabled={
              requestData?.requestStatus.id === REQUEST_STATUS.UNDER_REVIEW.id
            }
            className="w-38 bg-[var(--brand-green)] select-none"
          >
            Iniciar Análise
          </Button>
        </PageHeader>
        <PageContent>
          <div className="w-full mb-6 mt-6 flex justify-between">
            <div className="flex gap-5 items-center">
              <div className="flex items-center gap-2">
                <RequestTitle title="Análise" />
                <RequestTitle
                  title={`#${formatRequestProtocol(requestData?.protocol)}`}
                />
              </div>
              <RequestStatus name={status?.name} color={status?.color} />
            </div>
            <div className="flex items-center gap-10">
              <div>
                <OpenAcademicTranscript
                  disabled={true}
                  link={
                    requestData?.previousEducation?.academicTranscript || '#'
                  }
                />
              </div>
              <RequestActionButton
                buttonDisabled={true}
                requestId=""
                formMethods={formMethods}
                grantActive={true}
                denyActive={true}
              />
            </div>
          </div>
          <RequestData
            createdAt={requestData?.createdAt}
            desiredCourse={requestData?.desiredEducation?.desiredEducation}
            name={requestData?.student?.person?.name}
            previousCourse={requestData?.previousEducation?.name}
            ra={requestData?.student?.ra}
            status={requestData?.requestStatus?.name}
            desiredEducationLabel="Curso para Aproveitamento"
          />

          <div className="mt-12">
            <CoursesEquivalences
              currentCurriculum={currentCurriculum}
              formMethods={formMethods}
              request={requestData}
              onlyView={true}
            />
          </div>

          <div className="w-full mt-12 mb-6">
            <RequestTitle title="Simulação do Novo Histórico do Aluno" />
          </div>
          <SimulatedTranscript
            subTitle={requestData?.desiredEducation?.desiredEducation}
            courses={curriculumCourses}
            formMethods={formMethods}
            onlyView={true}
          />
        </PageContent>
      </PageLayout>

      <StartReviewModal
        isOpen={openReviewModal}
        setOpen={setOpenReviewModal}
        isPendingStartReview={isPendingStartReview}
        submitButtonAction={handleMutate}
      />

      <StartedReviewModal
        isOpen={openSuccessModal}
        setOpen={handleSetSuccesModal}
        submitButtonAction={navigateToMenu}
        backButtonAction={navigateToThisReview}
      />
    </>
  )
}
